/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'./api/ContentFilterProviderAPI',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory'
], function(_, ContentFilterProviderAPI, APIFactory) {

	class ContentFilterPropertiesProvider {

		constructor(options) {
			this.content = options.content;
			this._api = APIFactory.createAPI(this, [ContentFilterProviderAPI]);
			this._key = 'properties';
			this.content.getFeature('ContentFilter').registerProvider(this._key, this.getAPI());
		}

		getAPI() {
			return this._api;
		}

		match({ selector }) {
			let match = false;
			for (let name in selector[this._key]){
				if (this.content.getPropertyValue(name) === selector[this._key][name]) {
					match = true;
				} else {
					match = false;
					break;
				}
			}
			return match;
		}
	}

	return ContentFilterPropertiesProvider;

});
